import { graphql } from '@search/gql-client/src';

export const SubscribeToOfferPriceChangeMutation = graphql`
mutation SubscribeToOfferPriceChangeMutation(
    $offerId: ID!,
    $email: String!,
    $price: PriceInput!,
    $frequency: FrequencyEnum,
) {
    subscribeToPriceChangePersonal(
        offerId: $offerId,
        email: $email,
        price: $price,
        frequency: $frequency,
    ) {
        isSubscribed
        firstError {
            __typename
            ... on BaseError {
                message
            }
            ... on AuthUserIdError {
                message
            }
            ... on SubscribeToPriceChangeErrorInvalidOfferId {
                message
            }
            ... on SubscribeToPriceChangeErrorEmptyPrice {
                message
            }
            ... on SubscribeToPriceChangeErrorEmptySubscriber {
                message
            }
            ... on SubscribeToPriceChangeErrorInvalidEmail {
                message
            }
            ... on SubscribeToPriceChangeErrorSubscriptionExists {
                message
            }
        }
    }
}
`;
